import { ControlledCustomSwitch } from 'components/TasksV2/UI/ControlledCustomSwitch'
import useLocaleText from 'components/useLocaleText'
import React from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { SettingItem } from './SettingItem'

interface SchedulePushSwitchProps {
  number: number
}

export const SchedulePushSwitch: React.FC<SchedulePushSwitchProps> = ({ number }) => {
  const { control } = useFormContext()

  const t_schedulePush = useLocaleText('enable_reminder_notification')

  return (
    <SettingItem
      number={number}
      title={t_schedulePush}
      control={
        <Controller
          as={ControlledCustomSwitch}
          name="send_schedule_push"
          control={control}
          valueName="isChecked"
          size="lg"
          onChange={([event]) => {
            return event.target.checked
          }}
        />
      }
    />
  )
}
